import { render, staticRenderFns } from "./DisclosureStatement.vue?vue&type=template&id=6f68ff30&scoped=true&"
import script from "./DisclosureStatement.vue?vue&type=script&lang=js&"
export * from "./DisclosureStatement.vue?vue&type=script&lang=js&"
import style0 from "./DisclosureStatement.vue?vue&type=style&index=0&id=6f68ff30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68ff30",
  null
  
)

export default component.exports